import { render, staticRenderFns } from "./AdminCampaigns.vue?vue&type=template&id=753a62a2&"
import script from "./AdminCampaigns.vue?vue&type=script&lang=js&"
export * from "./AdminCampaigns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports